<template>
<div>
  <div class="card card--transparent stripe-connect">
    <div class="card--container" v-if="!error">
      <h3>
        Please wait while we connect with your Stripe account.
      </h3>
      <h3 class="small-top">
        We'll forward you to your subdomain once completed.
      </h3> 
    </div>

    <div class="card--container" v-else>
      <h2>There was an error trying to connect with your stripe account</h2>
      <div>Error: {{error_description}}</div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      error: "",
      success: false
    }
  },
  created() {
    let {scope, code, error, error_description } = this.$route.query;
    this.error = error;
    this.error_description = error_description;
    if (scope && code) {
      this.connectWithStripe(scope, code);
    }
  },
  methods: {
    connectWithStripe(scope, authorizationCode) {
      axios.post(`${process.env.VUE_APP_API_URL}owners/company/connect_with_stripe/`, {scope, authorizationCode} )
        .then((response) => {
          this.success = true;
          setTimeout(() => {
            location.href = `${location.protocol}//${response.data.sub_domain}.${process.env.VUE_APP_DOMAIN}automated-registration`
          }, 5000)
        }).catch((response) => {
          this.error = true;
          if (response.status >= 500) {
            this.error_description = "There was a server error. Please try again later";
          } else {
            if (response.data.error_description) {
              this.error_description = response.data.error_description;
            } else {
              this.error_description = response.data;
            }
          }
        })
    }
  }
}
</script>

<style>
.stripe-connect {
  max-width: 600px;
  margin: 0px auto;
}

</style>
